import "./IphoneStyles.css";
import iphone from "../../assets/toss_iphone.png";
import appToss from "../../assets/charte/new-logo.png";
import appleBadge from "../../assets/app_store_badge.png";
import googlePlay from "../../assets/google_play.png";
import { useEffect } from "react";
import ScrollTrigger from "react-scroll-trigger";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const Iphone = () => {
  const { t } = useTranslation("common");

  //Animation on scroll
  const SlideLeftRotate = (elem) => {
    gsap.fromTo(
      elem,

      {
        x: -400,
        opacity: 0,
        rotate: -360,
      },
      {
        opacity: 1,
        x: 0,
        rotate: 0,
        duration: 1,
        scrollTrigger: {
          trigger: elem,
          start: "top center",
          end: "bottom center",

          toggleActions: "play none none none",
        },
      }
    );
  };

  useEffect(() => {
    SlideLeftRotate("#iphone");
  }, []);

  return (
    <div className="section-iphone">
      <img  id="iphone" src={iphone} alt="" />
      <div className="iphone-text">
        <h5> {t("home.pour_rester_co")}</h5>
        <h2 id="iphone-title">
          {" "}
          Application <label>TOSS</label>
        </h2>
        <p> {t("home.concu")}</p>
        <img  src={appToss} alt="" />
        <div className="download-links">
          {/* <p> {t("home.prochainement")} </p> */}

          <a href="https://play.google.com/store/apps/details?id=com.cssports.testapp2">
            <img  src={googlePlay} alt="" />
          </a>
          <a href="https://apps.apple.com/fr/app/toss-2023/id6446198811">
            <img  src={appleBadge} alt="" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Iphone;
